import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { hidePopup } from '../../../../common/redux/popup-manager/popup-manager.actions';
import { isDebossedEmbelishmentMethodPopupShownSelector } from '../../../../common/redux/popup-manager/popup-manager.selector';
import { DebossedEmbelishmentMethodPopup as DebossedEmbelishmentMethodPopupComponent } from './debossed-embelishment-method-popup';
export * from './debossed-embelishment-method-popup';
const selectors = createStructuredSelector({
  open: isDebossedEmbelishmentMethodPopupShownSelector
});
const actions = dispatch => ({
  onClose: () => {
    dispatch(hidePopup());
  }
});
const connector = connect(selectors, actions);
export const DebossedEmbelishmentMethodPopup = connector(DebossedEmbelishmentMethodPopupComponent);